export default __webpack_public_path__ + "e5b96d616d02ad12eddf08883eabf6ee.png";